import React from 'react';

import './Footer.scss';

const Footer = () => (
  <footer className="footer docs-footer">
    <div className="container">
      <div>
        Made with <i className="icon icon-heart" /> by <a href="https://www.availity.com/">Availity</a>
      </div>
    </div>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js